import {Subject} from './LearningStandards';

export interface CourseViewModel {
  title: string;
  description?: string;
  subject: string;
  organizationId?: string;
  image?: File;
  structure: string;
  structureAmount: string;
  isPublic: boolean;
  type: string;
  passingScore?: number;
  projectId?: string;
}

export interface Course {
  id?: string;
  courseId?: string;
  organizationId?: string;
  title: string;
  description: string;
  subjectId: string;
  image?: string;
  structure: number;
  structureAmount: number;
  subject?: Subject;
  passingScore?: number;
  isPublic: boolean;
  type: string;
  publishStatus?: number;
  dateLastPublished?: string;
  origin?: number;
  projectId?: string;
}

export const COURSE_ORIGIN_CREATED_BY_USER = 0;
export const COURSE_ORIGIN_MICROREELS = 1;

export interface CourseListItem {
  id: string;
  dateCreated: Date;
  dateUpdated: Date;
  organizationId: string;
  title: string;
  description: string;
  subjectTitle: string;
  averageGrade: number;
  // Not returned by the organization course list.
  structure?: number;
  type: number;
  isPublic: boolean;
  structureAmount?: number;
  image: string;
  lessonsNumber: number;
  enrollNumber: number;
  completedNumber: number;
  published: boolean;
  projectId?: string | null;
  projectName?: string | null;
}

export interface CourseInstructor {
  instructorId: string;
  instructor: {
    userName: string;
    email: string;
  };
}

export const COURSE_NOT_PUBLISHED_STATUS = 0;
export const COURSE_PUBLISHING_STATUS = 1;
export const COURSE_PUBLISHED_STATUS = 2;
